import { render } from "./BlogIndex.vue?vue&type=template&id=13737475"
import script from "./BlogIndex.vue?vue&type=script&lang=js"
export * from "./BlogIndex.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__